/** @format */

const Textarea = ({ field, onChangeValue, teamForm }) => {
	return (
		<div className='form-group d-flex flex-column'>
			<label>{field.label}</label>
			<textarea
				onChange={(e) => onChangeValue(field.name, e.target.value, teamForm)}
				type='text'
				defaultValue={field?.value ?? ''}
				className='form-control f-13'></textarea>
		</div>
	);
};

export default Textarea;
